import "./index.scss";

import { QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";

import { queryClient } from "@/app/queryClient";
import { useAuthStore } from "@/stores/AuthStore";

import App from "./App";

// Revalidate the session against the httpOnly cookie (/auth/me) on boot so the
// SPA rehydrates an existing login before the first render-driven request.
void useAuthStore.getState().hydrate();

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
